import CT from '@marketplace-ai/tags';
import { WizardProps } from '../constants';
import { WizardFooter } from './WizardFooter';

const TAGS = CT.peerRef.form;

export const Welcome = (props: WizardProps) => {
  const { actor } = props;

  const nextBtn = {
    text: 'Next',
    onClick: () => {
      actor.send({ type: 'ON_WIZ_NEXT_PAGE' });
    },
  };

  return (
    <>
      <div data-cy={TAGS.welcome} className="mx-auto max-w-3xl text-left">
        <h2 className="sub-heading-sb mb-5 text-grey-100">Peer Reference Request</h2>
        <div className="space-y-5">
          <p className="text-sm font-normal leading-7 text-content-secondary">
            You have been selected to provide a professional reference for a healthcare provider
            seeking credentialing or employment verification. Your honest and thorough assessment is
            essential to maintaining the highest standards of patient care and professional
            integrity. Please complete all sections of this form accurately, providing specific
            details where requested. Your responses will be kept confidential and used solely for
            credentialing purposes.
          </p>
          <p className="text-sm font-normal leading-7 text-content-secondary">
            Thank you for taking the time to support your colleague's professional advancement.
          </p>
        </div>
      </div>
      <WizardFooter nextBtn={nextBtn} />
    </>
  );
};
